import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Accordion, MultiColumnList } from '@folio/stripes/components';
import css from './SafeDeleteInstancePage.css';

const ExpandableItemsDetails = ({ unavailableItems = [] }) => {
  const intl = useIntl();
  const [isExpanded, setIsExpanded] = useState(false);

  if (unavailableItems.length === 0) {
    return null;
  }

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const columnMapping = {
    barcode: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.safeDelete.itemBarcode"
        defaultMessage="Barcode"
      />
    ),
    status: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.safeDelete.itemStatus"
        defaultMessage="Status"
      />
    ),
    location: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.safeDelete.itemLocation"
        defaultMessage="Location"
      />
    ),
    callNumber: (
      <FormattedMessage
        id="ui-plugin-inventory-templates.safeDelete.itemCallNumber"
        defaultMessage="Call Number"
      />
    ),
  };

  const visibleColumns = ['barcode', 'status', 'location', 'callNumber'];

  const contentData = unavailableItems.map((item, index) => ({
    ...item,
    barcode: item.barcode || intl.formatMessage({
      id: 'ui-plugin-inventory-templates.safeDelete.field.notAvailable',
      defaultMessage: 'N/A',
    }),
    status: item.status || intl.formatMessage({
      id: 'ui-plugin-inventory-templates.safeDelete.status.unknown',
      defaultMessage: 'Unknown',
    }),
    location: item.location || intl.formatMessage({
      id: 'ui-plugin-inventory-templates.safeDelete.field.notAvailable',
      defaultMessage: 'N/A',
    }),
    callNumber: item.callNumber || intl.formatMessage({
      id: 'ui-plugin-inventory-templates.safeDelete.field.notAvailable',
      defaultMessage: 'N/A',
    }),
  }));

  return (
    <div className={css.expandableItemsDetails}>
      <Accordion
        open={isExpanded}
        onToggle={toggleExpanded}
        label={
          <FormattedMessage
            id="ui-plugin-inventory-templates.safeDelete.unavailableItemsHeader"
            defaultMessage="Unavailable Items Details ({count})"
            values={{ count: unavailableItems.length }}
          />
        }
        displayWhenClosed={
          <FormattedMessage
            id="ui-plugin-inventory-templates.safeDelete.showItemsDetails"
            defaultMessage="Show {count} unavailable items"
            values={{ count: unavailableItems.length }}
          />
        }
        // displayWhenOpen={
        //   <FormattedMessage
        //     id="ui-plugin-inventory-templates.safeDelete.hideItemsDetails"
        //     defaultMessage="Hide unavailable items"
        //   />
        // }
      >
        <MultiColumnList
          contentData={contentData}
          visibleColumns={visibleColumns}
          columnMapping={columnMapping}
          interactive={false}
          className={css.unavailableItemsList}
        />
      </Accordion>
    </div>
  );
};

ExpandableItemsDetails.propTypes = {
  unavailableItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      barcode: PropTypes.string,
      status: PropTypes.string,
      location: PropTypes.string,
      callNumber: PropTypes.string,
    }),
  ),
};

export default ExpandableItemsDetails;
